export default "__VITE_ASSET__sM7lKWVk__"